import { useAnimation } from 'framer-motion';
import { useEffect } from 'react';

import LazyLoadImage from '../../../uiParts/LazyLoadImage/LazyLoadImage';
import FadeIn from '../../../uiParts/FadeIn/FadeIn';

import styles from './ProjectCaptures.module.css';

interface Props {
  captures: string[];
}

export default function ProjectCaptures({ captures }: Props) {
  const control = useAnimation();

  useEffect(() => {
    control.start('show');
  }, [control]);

  const lists = captures.map((src, i) => {
    return (
      <FadeIn
        key={`cap-${i}`}
        controls={control}
        yOffset={-20}
        xOffset={i % 2 === 0 ? -20 : 20}
        easing={[0.33, 1, 0.68, 1]}
        duration={1}
      >
        <LazyLoadImage
          width={480}
          height={1000}
          src={src}
          option="blur"
          alt="test"
          threshold={0.01}
        />
      </FadeIn>
    );
  });

  return <div className={styles.grid}>{lists}</div>;
}
